<template>
    <div class="workflow-details">
        <div class="row workflow-details-info">
            <div class="col-12 col-md-6 col-xl-4 description-wrapper">
                <div class="description">
                    <p>
                        {{ $t('workflow.reader_distraction_due_to_textual_content') }}
                    </p>
                    <br />

                    <h5>{{ $t('workflow.where_can_i_find_it') }}?</h5>
                    <p>
                        {{ $t('workflow.lorem_ipsum_variations') }}
                    </p>
                </div>
            </div>
            <div class="col-12 col-md-6 col-xl-6 offset-xl-1 media-wrapper">
                <div class="media">
                    <div class="custom-yt-icon">
                        <span class="fa-layers fa-fw">
                            <i
                                class="fa-solid fa-square icon-bg"
                                data-fa-transform="shrink-6"></i>
                            <i class="fa-brands fa-youtube icon"></i>
                        </span>
                    </div>

                    <img
                        src="https://images.unsplash.com/photo-1605826832916-d0ea9d6fe71e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80"
                        :alt="$t('workflow.editor_in_chief')" />
                </div>
                <div class="gallery">
                    <design-2021-workflow-show-gallery-slider-component :gallery-in="gallery">
                    </design-2021-workflow-show-gallery-slider-component>
                </div>
            </div>
        </div>

        <div class="workflow-assignments">
            <h3 class="title">{{ $t('workflow.assignments') }}</h3>

            <div class="row">
                <div
                    class="col-12 col-md-6 col-xl-3 d-flex flex-column"
                    v-for="assignment of assignments"
                    :key="assignment.id">
                    <workflow-detail-assignment-card-component
                        :assignment-in="assignment"
                        @open-modal="showAssignmentModal">
                    </workflow-detail-assignment-card-component>
                </div>
            </div>
        </div>
        <workflow-detail-assignment-modal-component ref="assignmentModal"></workflow-detail-assignment-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-workflow-show-component',
    data() {
        return {
            gallery: [
                {
                    id: 12,
                    title: this.$t('workflow.newspaper_headlines'),
                    path: 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
                },
                {
                    id: 45,
                    title: this.$t('workflow.meeting'),
                    path: 'https://images.unsplash.com/photo-1557804506-e969d7b32a4b?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1145&q=80',
                },
                {
                    id: 27,
                    title: 'Fake news',
                    path: 'https://images.unsplash.com/photo-1636188540036-1879f679c2b0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1761&q=80',
                },
                {
                    id: 150,
                    title: 'News',
                    path: 'https://images.unsplash.com/photo-1584713503693-bb386ec95cf2?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80',
                },
                {
                    id: 5,
                    title: 'News coverage',
                    path: 'https://images.unsplash.com/photo-1581092787765-e3feb951d987?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
                },
                {
                    id: 33,
                    title: 'Camera setup',
                    path: 'https://images.unsplash.com/photo-1497015289639-54688650d173?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1632&q=80',
                },
                {
                    id: 10,
                    title: 'Interview',
                    path: 'https://images.unsplash.com/photo-1554200876-907f9286c2a1?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
                },
            ],
            skillSet: [
                {
                    id: 12,
                    title: this.$t('workflow.social_innovation'),
                    max: '10',
                    value: 9,
                },
                {
                    id: 2,
                    title: this.$t('workflow.digitalization'),
                    max: '10',
                    value: 7,
                },
                {
                    id: 92,
                    title: this.$t('workflow.products'),
                    max: '10',
                    value: 3,
                },
                {
                    id: 55,
                    title: this.$t('workflow.digital_presentation_skills'),
                    max: '10',
                    value: 5,
                },
            ],
            assignments: [
                {
                    id: 101,
                    title: this.$t('workflow.reporter_central_redaction_ad'),
                    short_description: this.$t(
                        'workflow.as_a_reporter_you_are_partly_responsible_for_the_news_gathering_of_the_ad_and_affiliated_titles_you_write_stories_for_our_online_platforms_which_also_appear_in_the_newspaper_you_work_as_a_team_and_are_managed_by_a_team_of_news_chiefs',
                    ),
                    image_path:
                        'https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
                    school_grade: 3,
                    school_level: 4,
                    duration: this.$t('workflow.thirteen_weeks'),
                },
                {
                    id: 20,
                    title: this.$t('workflow.communication_advisor'),
                    short_description:
                        'Lorem ipsum dolor sit amet, consectetur adipiscing elit. In condimentum libero vel sapien fermentum imperdiet. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Integer auctor lacinia metus, a commodo mi posuere nec.',
                    image_path:
                        'https://images.unsplash.com/photo-1557804506-669a67965ba0?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1074&q=80',
                    school_grade: 3,
                    school_level: 3,
                    duration: this.$t('workflow.nine_weeks'),
                },
                {
                    id: 78,
                    title: this.$t('workflow.communication_media_and_redaction'),
                    short_description:
                        'Nam sit amet condimentum lacus. Praesent in lacinia urna. Pellentesque efficitur ultrices faucibus. Ut sapien nisi, congue et malesuada nec, ultricies ac nibh. Vestibulum sodales felis odio, non vestibulum dolor pharetra et.',
                    image_path:
                        'https://images.unsplash.com/photo-1551434678-e076c223a692?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80',
                    school_grade: 4,
                    school_level: 4,
                    duration: this.$t('workflow.sixteen_weeks'),
                },
                {
                    id: 40,
                    title: this.$t('workflow.videographer'),
                    short_description: this.$t(
                        'workflow.a_cameraman_makes_video_recordings_for_tv_film_or_video_productions_this_includes_filming_during_a_concert_or_performance_but_also_soaps_drama_theater_talk_shows_or_documentaries_and_current_affairs_depending_on_what_the_cameraman_has_to_film_he_can_work_inside_a_studio_or_set_or_on_location',
                    ),
                    image_path:
                        'https://images.unsplash.com/photo-1589337068036-86d6826cd3a9?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1171&q=80',
                    school_grade: 4,
                    school_level: 4,
                    duration: this.$t('workflow.3_weeks'),
                },
            ],
        };
    },

    methods: {
        showAssignmentModal(assignment) {
            this.$refs.assignmentModal.show(assignment);
        },
    },
};
</script>

<style scoped lang="scss">
.fa-layers {
    display: inline-block;
    height: 1em;
    position: relative;
    text-align: center;
    vertical-align: -0.125em;
    width: 1em;
}

.fa-fw {
    text-align: center;
    width: 1.25em;
}

.workflow-details {
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.workflow-details-info,
.skills-and-visuals {
    margin-bottom: map-get($grid-gutter-spacing, 'sixty');
}

.description-wrapper {
    margin-bottom: $grid-gutter-width;
}

.description {
    font-size: $base-font-size;
    line-height: 1.5;
}

.gallery-wrapper {
    margin-bottom: $grid-gutter-width;
}

.media {
    position: relative;
    height: 325px;
    display: flex;
    flex-direction: row;
    column-gap: $grid-gutter-width;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');

    .icon {
        position: relative;
        font-family: 'Font Awesome 5 Brands';
        font-size: 4.6875rem;
        font-style: normal;
        color: $danger;
        z-index: 10;
    }

    .custom-yt-icon {
        position: absolute;
        left: calc(50% - 42px);
        top: calc(50% - 56px);
    }

    .icon-bg {
        color: $white;
        font-family: 'Font Awesome 5 Pro';
        font-weight: 900;
        font-style: normal;
        position: absolute;
        top: 30px;
        left: 30px;
        font-size: 32px;
        z-index: 1;
    }

    img {
        height: 100%;
        width: 100%;
        object-fit: cover;
        object-position: center;
        border-radius: 12px;
    }
}

.workflow-assignments {
    .title {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .gallery-wrapper {
        margin-bottom: 0;
    }
}
</style>
